import { useQuery } from "@tanstack/react-query";
import type { ViewEntityType } from "@colab/shared";
import { apiFetch } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { SavedView, SavedViewsListResponse } from "./types";

// GET /api/admin/views?entityType=<...>
//
// Backs the SavedViewTabs strip on every list page that wraps in the
// shared <SavedViewTabs entityType={...}> primitive. Sorted server-side by
// (position ASC, created_at ASC). 5-minute staleTime: list pages re-mount
// frequently as users navigate between sections, but the views list
// changes rarely (admin opens the Save dialog or drags to reorder); 5min
// is well below the average return-visit cadence.

export function useViews(entityType: ViewEntityType) {
  return useQuery<SavedView[]>({
    queryKey: queryKeys.views.list(entityType),
    queryFn: async () => {
      const data = await apiFetch<SavedViewsListResponse>(
        `/admin/views?entityType=${encodeURIComponent(entityType)}`,
      );
      return data.views;
    },
    staleTime: 5 * 60 * 1000,
  });
}
